<template lang="pug">
div
  h3 {{$t('groupPages.modules.pictures.title')}}
  ul.pictures(v-sortable="{onUpdate: onListReorder, handle: '.drag-handle'}")
    li(v-for="(picture, index) in shownPictures", :style="{'background-image': 'url('+picture.src+')'}", @click="clickThumbnail(picture, index)")
      template(v-if="openEditor")
        //- i.text-muted.fa.fa-arrows.drag-handle
        i.text-danger.fa.fa-trash(@click.stop="remove(picture)")
  div(v-if="openEditor", @click="askUpload", role='button')
    .alert.alert-info.text-center
      i.fa.fa-upload.fa-2x
      br
      |  {{$t('groupPages.modules.pictures.import')}}
  .pcenter(v-if="module.items.length > limit")
    button.btn.btn-default(@click="showMore") {{$t('groupPages.modules.pictures.more')}}
  .pswp(tabindex='-1', role='dialog', aria-hidden='true', ref="pswp")
    //
      Background of PhotoSwipe.
      It's a separate element as animating opacity is faster than rgba().
    .pswp__bg
    // Slides wrapper with overflow:hidden.
    .pswp__scroll-wrap
      //
        Container that holds slides.
        PhotoSwipe keeps only 3 of them in the DOM to save memory.
        Don't modify these 3 pswp__item elements, data is added later on.
      .pswp__container
        .pswp__item
        .pswp__item
        .pswp__item
      // Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed.
      .pswp__ui.pswp__ui--hidden
        .pswp__top-bar
          // Controls are self-explanatory. Order can be changed.
          .pswp__counter
          button.pswp__button.pswp__button--close(title='Close (Esc)')
          button.pswp__button.pswp__button--share(title='Share')
          button.pswp__button.pswp__button--fs(title='Toggle fullscreen')
          button.pswp__button.pswp__button--zoom(title='Zoom in/out')
          // Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR
          // element will get class pswp__preloader--active when preloader is running
          .pswp__preloader
            .pswp__preloader__icn
              .pswp__preloader__cut
                .pswp__preloader__donut
        .pswp__share-modal.pswp__share-modal--hidden.pswp__single-tap
          .pswp__share-tooltip
        button.pswp__button.pswp__button--arrow--left(title='Previous (arrow left)')
        button.pswp__button.pswp__button--arrow--right(title='Next (arrow right)')
        .pswp__caption
          .pswp__caption__center
  .cf
</template>
<script>
import _ from 'lodash'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/photoswipe-ui-default.min.js'
import 'photoswipe/dist/default-skin/default-skin.css'

import {success, error} from '@/components/shared/Notify'

import api from '@/utils/api'

export default {
  props: ['vueData', 'module', 'openEditor'],
  data () {
    return {limit: 20}
  },
  computed: {
    shownPictures () {
      return _.slice(this.items, 0, this.limit)
    },
    items () {
      let items = []
      for (let img of this.module.items) {
        items.push({
          src: img.downloadLink + '?size=2',
          href: img.downloadLink + '?size=3',
          description: img.name,
          width: img.extraData ? img.extraData.width : 0,
          height: img.extraData ? img.extraData.height : 0,
          id: img.id
        })
      }
      return items
    }
  },
  methods: {
    showMore () {
      this.limit += 20
    },
    askUpload () {
      this.$emit('askUpload')
    },
    clickThumbnail (picture, index) {
      const pswpElement = this.$refs.pswp

      const items = _.map(this.items, i =>
        ({
          src: i.href,
          w: i.width,
          h: i.height
        })
      )
      const options = {
        index,
        bgOpacity: 1,
        shareButtons: [
          {id: 'download', label: 'Télécharger l\'image', url: '{{raw_image_url}}', download: true}
        ]
      }
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options)
      gallery.init()
    },
    onListReorder (event) {
      // this.module.items.splice(event.newIndex, 0, this.module.items.splice(event.oldIndex, 1)[0])
      // const oldItems = this.module.items
      // this.module.items = []
      // this.$nextTick(() => {
      //   this.module.items = oldItems
      //   console.log('new list', this.module.items)
      // })
    },
    remove (item) {
      let index = _.findIndex(this.module.items, t => t.id === item.id)
      item = this.module.items[index]
      this.module.items.splice(index, 1)
      api.put('/node', {
        id: item.id,
        kind: 'file',
        public: false
      }).then((response) => {
        success(this._i18n.t('groupPages.modules.pictures.remove.success'))
      }).catch((err) => {
        if (err.response.data.error === 'CanNotBePrivate') {
          this.module.items.splice(index, 0, item)
          error(this._i18n.t('groupPages.modules.pictures.remove.error'))
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPagePictures.vue?199ddafe